import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class productReviewsOverview {
	static classname = 'product-reviews-overview';

	constructor($overview) {
		this.$overview = $overview;

		this.bindEvents();
	}

	get is_modal() {
		return this.$overview.data('modal') == 1;
	}

	set rate(rate) {
		$('.product-review').each(function () {
			const $review = $(this);
			const review_rate = $review.data('review_rate');

			$review.toggle(review_rate == rate);
		});

		if (this.is_modal) {
			ModalUtil.close();
		}
	}

	bindEvents() {
		const self = this;

		this.$overview.find('.product-reviews-overview__rate').click(function () {
			const rate = $(this).data('rate');

			self.rate = rate;
		});
	}
}
